import type { FunctionalComponent } from "vue"
import { PhaseSteps } from "@/types"
import { ALPHA_PAGE_BEST_SELLERS, ALPHA_PAGE_BLOCKS, ALPHA_PAGE_OVERVIEW, ALPHA_PAGE_RANGE_REVIEW } from "@/utils/alpha/sales-analysis.pages"
import {
  BestSellersIcon,
  BlockIcon,
  ChannelsIcon,
  DashboardIcon,
  LineChartIcon,
  PageIcon,
  ProductsIcon,
  SalesIcon,
  SettingIcon,
} from "@kaleidoscope-solutions/ks-icons/vue/light"

// TODO(Matt) - temporary file to wrap some of the hardcoded names used around the platform during alpha
// https://github.com/kaleidoscope-solutions/ks-ui-web/issues/489

export const ALPHA_PRODUCTS = "Products"
export const ALPHA_PRODUCT = "Product"
export const ALPHA_CHANNELS = "Channels"
export const ALPHA_CHANNEL = "Channel"
export const ALPHA_SALES = "Sales"
export const ALPHA_VARIANT_ID = "Product with variations"
export const ALPHA_QUANTITY_SOLD = "Quantity sold"
export const ALPHA_UNIT_PRICE = "Unit Price"
export const ALPHA_UNIT_COST = "Unit Cost"
export const ALPHA_DATE = "Date"
export const ALPHA_TABLE_MYO = "Make your own"

export const ALPHA_ATTR_PRODUCT = "Product"
export const ALPHA_ATTR_SIZE = "Size"
export const ALPHA_ATTR_COLOR = "Color"
export const ALPHA_ATTR_STYLE = "Style"
export const ALPHA_ATTR_PRODUCT_LINE = "Product line"
export const ALPHA_WEIGHTING_COLUMN = "Weighting Column"
export const ALPHA_SETTINGS = "Settings"

export const ALPHA_PRODUCTS_ATTRS = [
  ALPHA_ATTR_PRODUCT,
  ALPHA_ATTR_SIZE,
  ALPHA_ATTR_COLOR,
  ALPHA_ATTR_STYLE,
  ALPHA_ATTR_PRODUCT_LINE,
]

export const ALPHA_APP_TOOLTIP = new Map<string, string>([
  [
    ALPHA_QUANTITY_SOLD,
    `It is the amount of each product with variations you sold. 
  It can be named differently, depending on the file.`,
  ],
  [
    "Channel",
    `It’s where the file comes from. 
  For example, if your file comes from Amazon, the channel will be Amazon
  `,
  ],
  [
    ALPHA_VARIANT_ID,
    `Product with variations is a combination of the product name and its attributes. 
  For example, if you sell Polo shirt in different colors and sizes, Product with variations will be: 
  Polo shirt blue medium.
  
  It can be named and look different (i.e. with separators), depending on the file.`,
  ],
  [
    ALPHA_DATE,
    `It’s the date your product with variations were sold.
  It can be named differently, depending on the file.`,
  ],
  [
    ALPHA_WEIGHTING_COLUMN,
    `Column to weight by`
  ]
])

export const FILE_IMPORT_BANNERS = new Map<PhaseSteps, string>([
  [
    PhaseSteps.SELECT,
    `Information about **Quantity sold**, **Product with variations** and **Date** will enable you to perform analysis of your sales across your Channels.

  Tell Kaleidoscope where to find this information by **selecting the corresponding column from the file** (or simply review our guesses if any).`,
  ],
])

export function getPageIcon(pageName: string): FunctionalComponent {
  const pageIconMap: Record<string, FunctionalComponent> = {
    [ALPHA_PAGE_BEST_SELLERS]: BestSellersIcon,
    [ALPHA_PAGE_BLOCKS]: BlockIcon,
    [ALPHA_PAGE_OVERVIEW]: DashboardIcon,
    [ALPHA_PAGE_RANGE_REVIEW]: LineChartIcon,
    [ALPHA_PRODUCTS]: ProductsIcon,
    [ALPHA_PRODUCT]: ProductsIcon,
    [ALPHA_CHANNELS]: ChannelsIcon,
    [ALPHA_CHANNEL]: ChannelsIcon,
    [ALPHA_SALES]: SalesIcon,
    [ALPHA_SETTINGS]: SettingIcon,
  }

  return pageIconMap[pageName] ?? PageIcon
}

export function parseListData(listData: string) {
  return listData?.split("\n").slice(1, -1) || []
}
